import React, { useState } from 'react';
import checked from 'assets/images/checkbox/checked.svg';
import notChecked from 'assets/images/checkbox/notChecked.svg';
import cn from 'classnames';
import loader from 'assets/images/login/loader.svg';
import styles from './styles.scss';
import Modal from '../../Modal/Modal';
import Button from '../../common/Button/Button';
import { useSelector } from 'react-redux';
import { ROOT_URL } from '../../../constants/Config';
import { useTranslation } from 'react-i18next';

const periods = {
  0: '1 меc.',
  1: '6 мес.',
  2: '12 мес.'
};

const data = {
  '10 человек': {
    0: {
      id: 96,
      price: '10 000 ₽',
      altPrice: ''
    },
    1: {
      id: 99,
      price: '48 000 ₽',
      altPrice: ''
    },
    2: {
      id: 102,
      price: '96 000 ₽',
      altPrice: ''
    }
  },
  '10-30 человек': {
    0: {
      id: 97,
      price: '15 000 ₽',
      altPrice: ''
    },
    1: {
      id: 100,
      price: '72 000 ₽',
      altPrice: '90 000 ₽'
    },
    2: {
      id: 103,
      price: '144 000 ₽',
      altPrice: '180 000 ₽'
    }
  },
  '30+ человек': {
    0: {
      id: 98,
      price: '15 990 ₽',
      altPrice: '20 000 ₽'
    },
    1: {
      id: 101,
      price: '96 000 ₽',
      altPrice: '120 000 ₽'
    },
    2: {
      id: 104,
      price: '192 000 ₽',
      altPrice: '240 000 ₽'
    }
  }
};

const getCards = (period) => Object.keys(data).map(count => ({
  count,
  ...data[count][period]
}));

const infoModalClasses = {
  titleClassName: styles.ModalTitle,
  bodyClassName: styles.ModalBody,
  closeClassName: styles.ModalClose
};

const infoModalStyle = {
  maxWidth: '623px',
  width: 'calc(100% - 40px)'
};

const isCountPeopleError = (countPeople, index) => {
  if (index === 0) {
    return countPeople > 10;
  }

  if (index === 1) {
    return countPeople > 30;
  }

  return false;
};
async function readBlobAsync(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function(event) {
      const text = event.target.result;
      resolve(text);
    };

    reader.onerror = function(event) {
      reject(event.target.error);
    };

    // Начать чтение Blob как текст
    reader.readAsText(blob);
  });
}

export const TariffModal = ({ onClose }) => {
  const { t } = useTranslation();
  const { company, profile } = useSelector(({ company, profile }) => ({ company, profile }));
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);

  const { inn, kpp, tariffId } = company.data;
  const [selectedId, setSelectedId] = useState(tariffId ? +tariffId : 0);

  const [time, selectedTime] = useState(() => {
    return Object.keys(data).reduce((acc,index) => {
      if (acc !== null) {
        return acc;
      }

      Object.keys(data[index]).forEach(cardIndex => {
        if (data[index][cardIndex].id === selectedId) {
          acc = cardIndex
        }
      });

      return acc;
    }, null) || 0;
  });
  const cards = getCards(time);

  const { countPeople } = profile.tariff;

  if (error) {
    return (
      <Modal
        isOpen
        handleClose={onClose}
        classNames={infoModalClasses}
        title={t('components.profile.tariffModal.error.title')}
        contentStyle={infoModalStyle}
      >
        {t(`components.profile.tariffModal.error.${error}`, {
          count: selectedIndex === 0 ? 10 : 30
        })}
      </Modal>
    );
  }

  if (!inn || !kpp) {
    return (
      <Modal
        isOpen
        handleClose={onClose}
        classNames={infoModalClasses}
        title={t('components.profile.tariffModal.emptyInnOrKpp.title')}
        contentStyle={infoModalStyle}
      >
        {t('components.profile.tariffModal.emptyInnOrKpp.body')}
      </Modal>
    );
  }

  const handleClick = async () => {
    if (isLoading || !selectedId) {
      return;
    }

    if(isCountPeopleError(countPeople, selectedIndex)) {
      setError("count")
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(`${ROOT_URL}/payments/invoice`, {
        responseType: 'blob',
        params: {
          inn,
          kpp,
          tariffId: selectedId
        }
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = objectUrl;
      a.download = 'счет.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      try {
        readBlobAsync(error.response.data)
          .then(result => JSON.parse(result))
          .then(response => {
            if (response.error.messages.includes('Can not find Contractor')) {
              setError("data");
              return
            }

            setError("default");
          })
      } catch (blobReadErr) {
        setError("default");
      }
    }
    setIsLoading(false);
  };

  return (
    <Modal
      isOpen
      title={t('components.profile.tariffModal.title')}
      handleClose={onClose}
      classNames={{
        titleClassName: styles.MainModalTitle
      }}
      footer={(
        <div className={styles.ButtonContainer}>
          <Button
            onClick={handleClick}
            className={cn(styles.Button, styles.ButtonSave, 'button-primary', 'button-primary--lg', {
              [styles.ButtonBlocked]: isLoading || !selectedId
            })}
          >
            {isLoading ? <img src={loader} /> : t('components.profile.tariffModal.button')}
          </Button>
        </div>
      )}
    >
      <div className={styles.Container}>
        <div className={styles.TimeSelector}>
          {Object.keys(periods).map(key => (
            <div
              key={`time-${key}`}
              onClick={() => {
                selectedTime(key);
              }}
              className={cn({
                [styles.TimeSelectorActive]: key == time
              })}
            >
              {periods[key]}
            </div>
          ))}
        </div>
        {cards.map((card, index) => {
          const isActive = card.id === (tariffId ? +tariffId : 0);
          const isSelected = card.id === selectedId;
          return (
            <div
              key={`${time}-${index}`}
              className={cn(styles.Taraff, { [styles.TaraffActive]: isSelected })}
              onClick={() => {
                setSelectedId(card.id);
                setSelectedIndex(index);
              }}
            >
              {isActive && (
                <div className={styles.TaraffActiveHint}>
                  {t('components.profile.tariffModal.current')}
                </div>
              )}
              <div className={styles.TaraffFirstColumn}>
                <div>Доступ для</div>
                <div>{card.count}</div>
              </div>
              <div className={styles.TaraffSecondColumn}>
                <div>
                  {card.altPrice ? (
                    <React.Fragment>
                      <span>
                        <span>{card.altPrice}</span>
                      </span>
                      <span>{card.price}</span>
                    </React.Fragment>
                  ) : (
                    <span className={styles.TaraffPrice}>{card.price}</span>
                  )}
                </div>
                {isSelected ? <img src={checked} alt="checked" /> : <img src={notChecked} alt="notChecked" />}
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/TariffModal/index.js